// [
//   [
//     1499040000000,      // Open time
//     "0.01634790",       // Open
//     "0.80000000",       // High
//     "0.01575800",       // Low
//     "0.01577100",       // Close
//     "148976.11427815",  // Volume
//     1499644799999,      // Close time
//     "2434.19055334",    // Quote asset volume
//     308,                // Number of trades
//     "1756.87402397",    // Taker buy base asset volume
//     "28.46694368",      // Taker buy quote asset volume
//     "17928899.62484339" // Ignore
//   ]
// ]

import { Bar } from 'public/charting_library/charting_library';
import { getHistoricalDataHoldStation } from './holdstation';

export interface BinanceHistoricalData {
    openTime: number;
    open: string;
    high: string;
    low: string;
    close: string;
    volume: string;
    closeTime: string;
    quoteAssetVolume: string;
    numberOfTrades: number;
    takerBuyVolume: string;
    takerQuoteVolume: string;
    ignore: string;
}

export async function getHistoricalData(
    isfuture: boolean,
    opts: {
        symbol: string;
        interval: string;
        limit: number;
        from?: number;
        to?: number;
    }
): Promise<Bar[]> {
    const queryParams: Record<string, any> = {
        symbol: opts.symbol,
        interval: opts.interval,
        limit: `${opts.limit}`,
    };

    // if (opts?.from) {
    //   queryParams.startTime = opts.from;
    // }

    if (opts?.to) {
        queryParams.endTime = opts.to;
    }
    const domain = isfuture
        ? 'https://fapi.binance.com/fapi/v1/klines'
        : 'https://api.binance.com/api/v3/uiKlines';
    const params = new URLSearchParams(queryParams);
    const url = `${domain}?${params.toString()}`;
    let data;

    try {
        const response = await fetch(url);
        data = {
            status: response.status,
            data: await response.json(),
        };

        if (data.status < 200 || data.status >= 400) {
            throw new Error(`${data.status}`);
        }

        const resp: any[] = await data.data;
        const result: BinanceHistoricalData[] = resp
            .filter((o) => o.length >= 12)
            .map((o) => {
                const ele: BinanceHistoricalData = {
                    openTime: o[0],
                    open: o[1],
                    high: o[2],
                    low: o[3],
                    close: o[4],
                    volume: o[5],
                    closeTime: o[6],
                    quoteAssetVolume: o[7],
                    numberOfTrades: o[8],
                    takerBuyVolume: o[9],
                    takerQuoteVolume: o[10],
                    ignore: o[11],
                };

                return ele;
            });

        return result.map((o) => {
            const ele: Bar = {
                time: o.openTime,
                /** Opening price */
                open: parseFloat(o.open),
                /** High price */
                high: parseFloat(o.high),
                /** Low price */
                low: parseFloat(o.low),
                /** Closing price */
                close: parseFloat(o.close),
                /** Trading Volume */
                volume: parseFloat(o.volume),
            };

            return ele;
        });
    } catch {
        return getHistoricalDataHoldStation(opts);
    }
}
